/**
 * Tujuan: Display tech stack icons with labels (Java removed per user request)
 * Caller: About.js
 * Dependensi: react-icons
 * Main Functions: Techstack()
 * Side Effects: None
 */
import React from "react";
import {
  DiPython,
  DiMysql,
  DiHtml5,
  DiCss3,
  DiJavascript1
} from "react-icons/di";
import { SiPostgresql, SiMongodb, SiPandas, SiNextdotjs } from "react-icons/si";

function Techstack() {
  return (
    <div className="tech-grid">

      <div className="tech-card">
        <DiPython />
        <span className="tech-label">Python</span>
      </div>
      <div className="tech-card">
        <SiPandas />
        <span className="tech-label">Pandas</span>
      </div>
      <div className="tech-card">
        <DiMysql />
        <span className="tech-label">MySQL</span>
      </div>
      <div className="tech-card">
        <SiPostgresql />
        <span className="tech-label">PostgreSQL</span>
      </div>
      <div className="tech-card">
        <SiMongodb />
        <span className="tech-label">MongoDB</span>
      </div>
      <div className="tech-card">
        <DiJavascript1 />
        <span className="tech-label">JavaScript</span>
      </div>
      <div className="tech-card">
        <SiNextdotjs />
        <span className="tech-label">Next.js</span>
      </div>
      <div className="tech-card">
        <DiHtml5 />
        <span className="tech-label">HTML5</span>
      </div>
      <div className="tech-card">
        <DiCss3 />
        <span className="tech-label">CSS3</span>
      </div>

    </div>
  );
}

export default Techstack;
